<div class="drink-card-container" *ngIf="drink" (click)="stoplist ? null : onCardClicked(); $event.stopPropagation()">
  <mat-card class="drink-card">
    <div class="image-container">
      <app-lazy-image class="drink-card-image" mat-card-image [class.stop-list]="stoplist" kind="drink"
        [imageUrl]="drink.image"
      ></app-lazy-image>
      <!-- Продуктовые баннеры -->
      <div class="banners" [class.stop-list]="stoplist">
        <app-label-banners [labels]="drink.labels"></app-label-banners>
      </div>

      <!-- Служебные баннеры -->
      <div class="info-banner">
        <span class="stoplist-banner" *ngIf="stoplist">{{ 'soldout' | translate }}</span>
      </div>

      <!-- Аллергены: в стоп-листе не показываются (заказать нельзя, место у «Закончилось») -->
      <app-allergen-pill class="allergen-pill" *ngIf="!stoplist" [allergens]="drink.allergens"></app-allergen-pill>
    </div>

    <mat-card-content class="drink-info" [class.stop-list]="stoplist">
      <div class="drink-info__title">
        <div class="drink-title" [innerHTML]="drink | fieldTranslate: 'title'"></div>
      </div>

      <!-- Price + size -->
      <mat-card-title class="drink-info__price" [class.stop-list]="stoplist">
        <span *ngIf="drink.variability" class="drink-price__from">{{ 'from' | translate }} </span>
        
        <!-- Price -->
        <ng-container *ngIf="drink.price | priceSeparator as separated">
          <span class="drink-price__whole">{{ separated.whole }}</span>
          <span class="drink-price__dot">{{ separated.separator }}</span>
          <span class="drink-price__fraction">{{ separated.fraction }}</span>
          <span class="drink-price__currency">{{ locale?.currency }}</span>
        </ng-container>

        <span class="drink-size" [class.stop-list]="stoplist" *ngIf="drink.size && !basketDrink">
          {{ drink.size }} {{ locale?.units?.get(drink.unit) }}
        </span>
      </mat-card-title>

      <div class="drink-info__count" *ngIf="basketDrink">
        <img src="assets/basket.svg" alt="basket" class="drink-basket-icon" />
        <span class="drink-count">{{ basketDrink.count }}</span>
      </div>
    </mat-card-content>
  </mat-card>
</div>